/* Lead time message — Eurus / Alpine (e.g. Bloomex USA) — PDP + collection + quick view.
 *
 * Include once. Render `lead-time-message-global-eurus.liquid` in product context.
 *
 * Scans: document, #Product-Drawer-Content, [id^="choose-options-template"],
 *   [id^="ProductInfo-choose-option"] (card choose-options flyout),
 *   #quickview-product-content (Eurus quick-view AJAX), quick-buy-modal shadowRoot
 * Debounced MutationObserver on childList (~160ms).
 * Dispatches lead-time-eurus:lead-time-ready + shared cache for checkbox script.
 */
(function () {
  if (window.LeadTimeMessageEurusInit) {
    return;
  }

  /** Single-flight + cache for POST /apps/api/products-lead-time (shared with checkbox script). */
  function parseLeadTimePayload(data) {
    return data && data.leadTime ? data.leadTime : data;
  }

  function dispatchLeadTimeReady(productId, leadTime) {
    document.dispatchEvent(
      new CustomEvent('lead-time-eurus:lead-time-ready', {
        bubbles: true,
        detail: { productId: String(productId), leadTime: leadTime }
      })
    );
  }

  function ensureLeadTimeFetched(productId) {
    var pid = String(productId);
    if (!/^\d+$/.test(pid)) {
      return Promise.reject(new Error('Lead time: invalid product id'));
    }

    window.__leadTimeEurusApiCache = window.__leadTimeEurusApiCache || {};
    var cache = window.__leadTimeEurusApiCache;
    if (cache[pid]) {
      return Promise.resolve(cache[pid]);
    }

    window.__leadTimeEurusInflight = window.__leadTimeEurusInflight || {};
    var inflight = window.__leadTimeEurusInflight;
    if (inflight[pid]) {
      return inflight[pid];
    }

    inflight[pid] = fetch('/apps/api/products-lead-time', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ productIds: [pid] })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Lead time endpoint error: ' + response.status);
        }
        return response.json();
      })
      .then(function (data) {
        var leadTime = parseLeadTimePayload(data);
        cache[pid] = leadTime;
        dispatchLeadTimeReady(pid, leadTime);
        return leadTime;
      })
      .catch(function (err) {
        delete cache[pid];
        throw err;
      })
      .finally(function () {
        delete inflight[pid];
      });

    return inflight[pid];
  }

  window.__leadTimeEurusEnsureLeadTime = ensureLeadTimeFetched;

  function showMessageFromLeadTime(container, productId, leadTime) {
    if (
      !leadTime ||
      typeof leadTime.leadTimeDays !== 'number' ||
      leadTime.leadTimeDays <= 0
    ) {
      return;
    }
    if (!leadTime.enforceUserAgreement) {
      return;
    }

    // Collection card choose-options flyout: checkbox only (no shipping line).
    if (container.closest('[id^="ProductInfo-choose-option"]')) {
      container.style.display = 'none';
      container.textContent = '';
      return;
    }

    var n = leadTime.leadTimeDays;
    var unit = n === 1 ? 'day' : 'days';
    container.textContent =
      'Product will be available for shipping in ' + n + ' ' + unit + '.';
    container.style.display = 'block';
  }

  function initContainer(container) {
    if (!container || container.dataset.leadTimeMessageBound) {
      return;
    }

    var productId = container.getAttribute('data-product-id');
    if (!productId || !/^\d+$/.test(productId)) {
      return;
    }

    container.dataset.leadTimeMessageBound = '1';

    ensureLeadTimeFetched(productId)
      .then(function (leadTime) {
        showMessageFromLeadTime(container, productId, leadTime);
      })
      .catch(function (error) {
        console.error('lead-time-message-global-eurus error:', error);
      });
  }

  function scan(scope) {
    if (!scope || !scope.querySelectorAll) {
      return;
    }
    scope
      .querySelectorAll('[data-lead-time-message-scope]')
      .forEach(function (container) {
        initContainer(container);
      });
  }

  function scanShadowRoots() {
    document.querySelectorAll('quick-buy-modal').forEach(function (modal) {
      if (modal.shadowRoot) {
        scan(modal.shadowRoot);
      }
    });
  }

  function scanChooseOptionsRoots() {
    document.querySelectorAll('[id^="choose-options-template"]').forEach(function (el) {
      scan(el);
    });
  }

  function scanProductInfoChooseOptionRoots() {
    document.querySelectorAll('[id^="ProductInfo-choose-option"]').forEach(function (el) {
      scan(el);
    });
  }

  function scanQuickViewContent() {
    var qv = document.getElementById('quickview-product-content');
    if (qv) {
      scan(qv);
    }
  }

  function scanAllRelevantRoots() {
    scan(document);
    scanChooseOptionsRoots();
    scanProductInfoChooseOptionRoots();
    scanQuickViewContent();
    var legacyDrawer = document.getElementById('Product-Drawer-Content');
    if (legacyDrawer) {
      scan(legacyDrawer);
    }
    scanShadowRoots();
  }

  var scanDebounceTimer;
  function scheduleScanAll() {
    clearTimeout(scanDebounceTimer);
    scanDebounceTimer = setTimeout(scanAllRelevantRoots, 160);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scanAllRelevantRoots();
  });

  document.addEventListener('quick-view:open', function () {
    scanAllRelevantRoots();
  });

  var rootObserver = new MutationObserver(function () {
    scheduleScanAll();
  });
  rootObserver.observe(document.documentElement, { childList: true, subtree: true });

  window.LeadTimeMessageEurusInit = {
    scan: scan,
    scanAll: scanAllRelevantRoots,
    init: initContainer
  };
})();
